import React from "react";
const RicosContext = React.createContext({
  locale: "en",
  localeContent: "en",
  experiments: {},
  isMobile: false,
  t: (text) => text,
  languageDir: "ltr",
  theme: {},
  portal: null,
  debugMode: [],
  platform: "macOs",
  content: null,
  jsdomMode: false,
  environment: "liveSite",
  tabIndex: 0
});
const RicosContextProvider = ({
  children,
  isMobile,
  locale,
  localeContent,
  experiments,
  languageDir,
  theme,
  t,
  portal,
  debugMode = [],
  jsdomMode = false,
  platform = "macOs",
  content = null,
  environment = "liveSite",
  tabIndex = 0
}) => {
  return /* @__PURE__ */ React.createElement(
    RicosContext.Provider,
    {
      value: {
        t,
        locale,
        localeContent,
        isMobile,
        experiments: experiments ?? {},
        languageDir,
        theme,
        portal: portal ?? null,
        debugMode,
        jsdomMode,
        platform,
        content,
        environment,
        tabIndex
      }
    },
    children
  );
};
function withRicosContext(Component) {
  return (props) => {
    return /* @__PURE__ */ React.createElement(RicosContext.Consumer, null, (value) => /* @__PURE__ */ React.createElement(Component, { ...props, ricosContext: value }));
  };
}
const RicosContextConsumer = ({ children }) => {
  return /* @__PURE__ */ React.createElement(RicosContext.Consumer, null, (value) => children(value));
};
export {
  RicosContext,
  RicosContextConsumer,
  RicosContextProvider,
  withRicosContext
};
//# sourceMappingURL=RicosContext.js.map
